/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import { DayPickerCalendar } from "./day_picker_calendar";

// Clamp a date to the range specified by start + number of units
const clampDateToRange = function(day, start, number, units) {
  if (day.diff(start, units) < number) {
    return day;
  } 
    return moment(start).add(number, units);
  
};

// Wrap DayPicker to allow selecting a date range
export var DateRangeCalendar = (function() {
  DateRangeCalendar = class DateRangeCalendar extends React.Component {
    static initClass() {
      this.propTypes = {
        // Start date of selected range
        start: PropTypes.instanceOf(moment).isRequired,
        // End date of selected range
        end: PropTypes.instanceOf(moment),
        // Maximum length of range that can be selected, in +rangeUnit+ units
        rangeLimit: PropTypes.number,
        // Units for +rangeLimit+
        rangeUnits: PropTypes.oneOf(['days', 'weeks', 'months', 'years']),
        // Callback when a new range is selected, with (start, end) params
        onDateRangeSelected: PropTypes.func
      };
  
      this.defaultProps = {
        start: moment(),
        end: moment(),
        rangeLimit: 1,
        rangeUnits: 'years'
      };
    }

    constructor(props) {
      super(props);
      this.UNSAFE_componentWillReceiveProps = this.UNSAFE_componentWillReceiveProps.bind(this);
      this.handleDayClick = this.handleDayClick.bind(this);
      this.handleDayMouseEnter = this.handleDayMouseEnter.bind(this);
this.render = this.render.bind(this);

      this.state = this.getInitialState(props);
    }

    getInitialState(props) {
      return {
        start:     moment(props.start).startOf('day'),
        end:       props.end ? moment(props.end).startOf('day') : null,
        enteredTo: null
      };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      if ((this.props.start !== nextProps.start) || (this.props.end !== nextProps.end)) {
        return this.setState(this.getInitialState(nextProps));
      }
    }

    handleCalendarContainerClick(event) {
      return event.preventDefault();
    }

    handleDayClick(day, modifiers, event) {
      event.preventDefault();
      day = moment(day).startOf('day');

      if (this.state.start && this.state.end) {
        // If a range is selected, reset the range
        return this.setState({start: day, end: null, enteredTo: null});
      } else if (day.isBefore(this.state.start, 'day')) {
        // If date is before the existing start, reset the range
        return this.setState({start: day, end: null, enteredTo: null});
      } 
        day = clampDateToRange(day, this.state.start, this.props.rangeLimit, this.props.rangeUnits);
        this.setState({end: day, enteredTo: day});
        return (typeof this.props.onDateRangeSelected === 'function' ? this.props.onDateRangeSelected(this.state.start, day) : undefined);
      
    }

    handleDayMouseEnter(day) {
      day = moment(day).startOf('day');

      if (this.state.start && this.state.end) {
        // Range selected, do nothing
        return;
      }

      // Allow hovering after date if it's within maxDayRange days of date, otherwise clamp it
      if (day.isSameOrAfter(this.state.start, 'day')) {
        return this.setState({enteredTo: clampDateToRange(day, this.state.start, this.props.rangeLimit, this.props.rangeUnits)});
      }
    }

    render() {
      // Compute the modifiers for React-Day-Picker

      // Selected range
      let disabledDays;
      const selectedDays = this.state.start && this.state.end ?
        { from: this.state.start.toDate(), to: (this.state.end != null ? this.state.end.toDate() : undefined) }
      : this.state.start && this.state.enteredTo ?
        { from: this.state.start.toDate(), to: this.state.enteredTo.toDate() }
      :
        [this.state.start.toDate()];

      // Disabled dates outside of the allowed range, but only while selecting the end date
      if (this.state.start && !this.state.end) {
        disabledDays = [
          {before: this.state.start.toDate()},
          {after: moment(this.state.start).add(this.props.rangeLimit, this.props.rangeUnits).toDate()}
        ];
      }

      // Markers for beginning, end
      const modifiers = {
        selected: selectedDays,
        start: this.state.start.toDate(),
        end: (this.state.end != null ? this.state.end.toDate() : undefined),
      };

      return <div id="em-filter-menu-date-selector-calendar"
            ref={this.props.elementRef}
            className="em-date-selector-calendar"
            onKeyDown={this.handleCalendarContainerKeyDown}
            onClick={this.handleCalendarContainerClick}>
        <DayPickerCalendar showOutsideDays={true}
                    navLayout="around"
                    enableOutsideDaysClick={true}
                    fixedWeeks={true}
                    defaultMonth={this.props.start.toDate()}
                    onDayClick={this.handleDayClick}
                    onDayMouseEnter={this.handleDayMouseEnter}
                    selected={selectedDays}
                    disabled={disabledDays}
                    modifiers={modifiers}
                    modifiersClassNames={{
                      start: 'rdp-day-selected-start',
                      end: 'rdp-day-selected-end'
                    }}
        />
      </div>;
    }
  };
  DateRangeCalendar.initClass();
  return DateRangeCalendar;
}());
